import React from 'react'
import kctestpic from '../images/kctest.jpeg'
import mariatestpic from '../images/mariatest.jpeg'
import samtestpic from '../images/samtest.jpeg'
import silviatestpic from '../images/silviatest.jpeg'
import charlottetestpic from '../images/charlottetest.jpeg'
import martatestpic from '../images/martatest.jpeg'
import oglahtestpic from '../images/oglahtest.jpeg'
import carotestpic from '../images/carotest.jpeg'
import philgonatestpic from '../images/philgonatestpic.jpeg'
import evanstestpic from '../images/evanstestpic.jpeg'


function Testimonials() {
  return (
    <div>
          <div className='section'>
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Maria and Wangeci</h1>
                <p>"Love your work! Always grand rising! It really looks amazing!"</p>
              </div>
            </div>

              <div className='image-section'>
                <img src={mariatestpic} alt="Event" className="carousel" />
              </div>
          </div>

          <div className='section reverse'>
            <div className='image-section'>
              <img src={samtestpic} alt="Event" className="image-left" />
            </div>
  
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Sam and Sly</h1>
                <p>"Sam and I lack the words to express our sincere gratitude for a decor work so well  done!
                The venue was spectacular, beautiful and elegant.
                Thank you so much for the beautiful work that you did to make our pre-wedding so special. We look forward to having you do our wedding decor!"</p>
              </div>
            </div>
          </div>

          <div className='section'>
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">KC GALA Team</h1>
                <p>"The decor was on point! Decor Delights and Events always delivering with excellence!"</p>
              </div>
            </div>

              <div className='image-section'>
                <img src={kctestpic} alt="Event" className="carousel" />
              </div>
          </div>

          <div className='section reverse'>
            <div className='image-section'>
              <img src={silviatestpic} alt="Event" className="image-left" /> 
            </div>
  
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Sam and Silvia</h1>
                <p>"What can we say?
                  This was spectacular, words are not enough!
                  Grateful for all the great job you did with the decoration. 
                  You did it again! 
                  Be blessed!"</p>
              </div>
            </div>
          </div>

          <div className='section'>
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Charlotte and Dami</h1>
                <p>"The decor for our wedding was excellent! It met every expectation for our enchanted forest theme. It all came together beautifully!"</p>
              </div>
            </div>

              <div className='image-section'>
                <img src={charlottetestpic} alt="Event" className="carousel" />
              </div>
          </div>

          <div className='section reverse'>
            <div className='image-section'>
              <img src={martatestpic} alt="Event" className="image-left" /> 
            </div>
  
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Marta W.</h1>
                <p>"Amazing decor services for my son's graduation! This is incredible and excellent!"</p>
              </div>
            </div>
          </div>

          <div className='section'>
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Oglah B.</h1>
                <p>"Extraordinary decor by an extraordinary team! You always do such an excellent job! Thanks you!"</p>
              </div>
            </div>

              <div className='image-section'>
                <img src={oglahtestpic} alt="Event" className="carousel" />
              </div>
          </div>

          <div className='section reverse'>
            <div className='image-section'>
              <img src={carotestpic} alt="Event" className="image-left" /> 
            </div>
  
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Caro and Jack </h1>
                <p>"We wanna take this opportunity and thank you for taking your time and doing the decoration. You did an amazing job, the deco was superb and on point 👌👌👌. It exceeded our expectations. We appreciate you a lot. Thank you, be blessed and may God open new doors and opportunities for you."</p>
              </div>
            </div>
          </div>

          <div className='section'>
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Evans K.</h1>
                <p>"A sincere thank you for the incredible work you did to make my Book Launch Event shine - Created for Love. I got a lot of very positive compliments about the decor! May God bless you abundantly."</p>
              </div>
            </div>

              <div className='image-section'>
                <img src={evanstestpic} alt="Event" className="carousel" />
              </div>
          </div>

          <div className='section reverse'>
            <div className='image-section'>
              <img src={philgonatestpic} alt="Event" className="image-left" /> 
            </div>
  
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">Philgona</h1>
                <p>"Love, love, love it 💖 Will definitely get you more referrals!"</p>
              </div>
            </div>
          </div>
         
    </div>
  )
}

export default Testimonials